import {useItemsDashboard} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {useFilters} from '../../components/filters';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {getApolloError, normalizeRuStr, cls} from '../../components/utils';
import {Spell, SpellSchool, useSpellsQuery} from '../../generated/types';
import {useRoute} from '../../lib/routes';
import {SpellView} from './view';
import {ConcentrationIcon, RitualIcon} from '../../components/spell-icons';
import {getAllTitles} from '../../components/render-helpers';
import {SpellSchools} from '../../components/enums';
import {SpellFilters, spellFilters, toSpellFilterInput} from './filters';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

type Props = {};

export const SpellsPage: React.FC<Props> = () => {
	const filters = useFilters(spellFilters);

	const router = useRoute();
	const query = router?.query || {};
	const variantId = query.variantId as string | undefined;

	const {data, loading, error} = useSpellsQuery({
		ssr: true,
		variables: {
			filters: toSpellFilterInput(filters.values),
		},
	});

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: data?.spells || [],
		id: query.id as string,
		loading,
		route: 'spell',
		baseRoute: 'spells',
		sidebarHeader: (spell) => spell.title,
		sidebarSecondary: (spell) => <>{SpellSchools[SpellSchool[spell.school]]} </>,
		sidebarBadge: (spell) => (
			<>
				{spell.duration[0]?.concentration && (
					<ConcentrationIcon width={16} height={16} role="img" aria-label="Концентрация" />
				)}
				{spell.ritual && <RitualIcon width={16} height={16} role="img" aria-label="Ритуал" />}
			</>
		),
		filterFn: (spell, str) => {
			const names = getAllTitles(spell as Spell);
			return names.some((name) => normalizeRuStr(name).includes(normalizeRuStr(str)));
		},
		groupBy: (spell) => spell.level,
		groupTitle: (spells) => (spells[0].level === 0 ? 'Фокусы' : `${spells[0].level}-й круг`),
		onOpenFilters: filters.toggle,
		isFiltersSet: filters.isSet,
	});

	const title = showView && selected ? selected.title : 'Заклинания';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="spells" />}
			{notFound && <NotFoundSeo />}
			<SpellFilters filters={filters} />
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && selected && showView ? (
								<SpellView baseId={selectedId} variantId={variantId} title={title} />
							) : (
								<div className={pageCss.fullSizeBlock}>Выберите заклинание</div>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
